import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, MapPin,/* Headset, */ Sparkles, CreditCard, Download } from 'lucide-react';
import '../styles/cover.css';
import catalogoPdf from '../data/catalogoCZ.pdf';

// Las ventajas salen de lo que el negocio ya ofrece: el envío gratis desde
// $500 es el mismo umbral que aplica el carrito, y el resto viene del
// banner y del pie de página.
const VENTAJAS = [
  {
    Icono: Truck,
    titulo: 'Envío gratis desde $500',
    detalle: 'Hasta la puerta de tu hogar',
  },
  {
    Icono: MapPin,
    titulo: 'Venta exclusiva en Culiacán',
    detalle: 'Servicio disponible únicamente en Culiacán, Sinaloa',
  },
  /*{
    Icono: Building2,
    titulo: 'Hogar, comercio e industria',
    detalle: 'Catálogo para cada necesidad',
  },
  {
    Icono: Headset,
    titulo: 'Atención personalizada',
    detalle: 'Te asesoramos en tu pedido',
  },*/
  {
  Icono: CreditCard,
  titulo: 'Crédito para negocios',
  detalle: 'Hasta 30 días para pagar tus compras',
},
];

const Cover = () => {
  const scrollToContacto = () => {
    const contacto = document.getElementById('contactanos');
    if (contacto) {
      const yOffset = -100;
      const y = contacto.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section className="cover" aria-label="Presentación de CleanZone">
      <div className="cover-intro">
        <span className="cover-intro-sheen" aria-hidden="true" />
        <span className="cover-intro-glint" aria-hidden="true">
          <Sparkles size={20} strokeWidth={1.8} />
        </span>

        <span className="cover-eyebrow">Distribuidora de productos de limpieza</span>

        <h1 className="cover-title">
          Soluciones profesionales en <span>limpieza</span>
        </h1>

        <p className="cover-subtitle">
          Papel institucional, limpiadores, desechables y equipo de limpieza para
          mantener impecable tu hogar, tu negocio o tu empresa.
        </p>

        <div className="cover-buttons">
          <Link to="/tienda" className="cover-btn cover-btn-primario">
            Ver tienda
          </Link>
          <button type="button" className="cover-btn cover-btn-secundario" onClick={scrollToContacto}>
            Contáctanos
          </button>
        </div>
      </div>
    
          
      <div className="cover-ventajas-fila">
          <ul className="cover-ventajas">
            {VENTAJAS.map(({ Icono, titulo, detalle }) => (
              <li key={titulo} className="cover-ventaja">
                <span className="cover-ventaja-icono">
                  <Icono size={20} strokeWidth={2.2} aria-hidden="true" />
                </span>
                <span className="cover-ventaja-texto">
                  <strong>{titulo}</strong>
                  <span>{detalle}</span>
                </span>
              </li>
            ))}
          </ul>

          <a
            href={catalogoPdf}
            download="Catalogo-CleanZone.pdf"
            className="cover-catalogo-btn"
          >
            <Download size={18} strokeWidth={2.2} aria-hidden="true" />
            Descargar catálogo PDF
          </a>
        </div>
      </section>
  );
};

export default Cover;
